import {
	Box,
	Button,
	Grid,
	makeStyles,
	Paper,
	Typography,
} from "@material-ui/core";
import { ARBITRATION, ARBITRATOR, CASE_MANAGER, CLAIMANT_COMPLETE, GENERAL, IO_INPROGRESS, MD_INPROGRESS, MEDIATOR, MUTHOOT_ACCEPT, MUTHOOT_SECRETARIAT, NODAL_INPROGRESS, RESPONDENT, RESPONDENT_INPROGRESS, RO_AFTER_REVIEW, SUB_ADMIN, VENDOR, WITNESS, ZONAL_COMPLETE, ZONAL_INPROGRESS } from "app/constants";
import React from "react";
import { useHistory } from "react-router-dom";
import { DocGenerator } from "utils";
import { MuthootCaseResolved, updateDispute, updateMuthootStatus } from "slices/disputeSlice";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import { KeyboardBackspace } from "@material-ui/icons";
import { format } from "date-fns";
import { useBackground } from "contexts/BackgroundContext";
import { calc_days, getMuthootRole } from 'features/disputes/MuthootDisputes/utils';
import { getClaimantAnswerData, getCaseTimeline } from 'features/disputes/MuthootDisputes/service';
import downloadIcon from '../../../images/download-02.svg';
import { updateCase } from "slices/casesSlice";
import { useDispatch } from "react-redux";
import ShowProgress from "./ShowProgress";
import ResponsibleDepartmentDialog from "./ResponsibleDepartmentDialog";
import { useResumeFilling } from "contexts/ResumeFilling";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: "2rem",
		[theme.breakpoints.down("sm")]: {
			marginTop: "1.5rem",
		},
		[theme.breakpoints.down("xs")]: {
			marginTop: "1rem",
		},
	},
	text: {
		fontFamily: `"Inter", "sans-serif"`,
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: "16px",
		lineHeight: "24px",
	},
	blue: {
		fontFamily: `"Inter", "sans-serif"`,
		color: "#2F80ED",
		lineHeight: "24px",
	},
	fonts: {
		lineHeight: "24px",
		fontSize: "16px",
		fontFamily: `"Inter", "sans-serif"`,
	},
	item: {
		"&:hover": {
			background: "#EEEEEE",
		},
	},
	calenderBtn: {
		fontSize: "16px",
		fontWeight: "400",
		color: "#2F80ED",
		textTransform: "none",
		borderRadius: "2px",
		border: "1px solid #2F80ED",
		boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.24)",
		width: "100%",
		maxWidth: "100%",
		"&:hover": {
			background: "#2F80ED",
			color: "#FFFFFF",
			border: "1px solid #2F80ED",
		},
		[theme.breakpoints.down("md")]: {
			fontSize: "16px",
		},
		[theme.breakpoints.down("xs")]: {
			fontSize: "14px",
		},
		hov: {
			"&:hover": {
				color: "#333333",
			},
		},
		btntext: {
			color: theme.palette.primary.main,
			fontFamily: "Satoshi-Bold",
			textTransform: "none",
		},
	},
	claimantDetailsContainer: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		padding: "2rem",
		borderRadius: '4px',
		backgroundColor: '#f4f8ff',
	},
	claimantDetailsHeading: {
		marginBottom: "1rem",
		fontSize: '1.5rem',
		lineHeight: '1.8rem',
		color: 'black'
	},
	claimantDetailsStatus: {
		borderRadius: '4px',
		padding: '8px',
		width: 'fit-content',
		lineHeight: 1,
	},
	claimantDetailsRow: {
		padding: '10px 0',
		borderBottom: '1px solid #d7dbe2',
		display: 'flex',
		gap: '10px',
		[theme.breakpoints.between("sm", 'md')]: {
			display: 'block',
		},
	},
	disputeStatusContainer: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		padding: "0.8rem 1rem 0.8rem 3rem",
	},
	disputeStatusHeading: {
		marginBottom: "0.5rem",
		fontSize: '1.3rem',
		lineHeight: '1.8rem',
		color: 'black'
	},
	button: {
		color: 'black',
		"&:disabled": {
			backgroundColor: '#0000001f',
			color: '#00000042',
		}
	}
}));


export default function DisputeDetailsMuthoot({
	activeDispute,
	activeCase,
	profile,
}) {
	const classes = useStyles();
	const history = useHistory();
	const { setBackground } = useBackground();
	const dispatch = useDispatch();
	const { setResume } = useResumeFilling();

	const IS_MEDIATOR = profile?.profile_type === MEDIATOR;
	const IS_ARBITRATOR = profile?.profile_type === ARBITRATOR;
	const IS_ADMIN = profile?.profile_type === SUB_ADMIN;
	const MUTHOOT_STATUS = activeDispute?.muthoot_status;
	const IS_END_USER = profile?.profile_type === GENERAL;
	const IS_GRO = profile?.profile_type === VENDOR;
	const IS_PNO = profile?.profile_type === CASE_MANAGER;
	const IS_REGIONAL_OFFICER = profile?.profile_type === MUTHOOT_SECRETARIAT;
	const IS_CALL_CENTER = profile?.profile_type === WITNESS;

	const [loading, setLoading] = React.useState(true);
	const [claimant, setClaimant] = React.useState("");
	const [claimantAnswers, setClaimantAnswers] = React.useState('');
	const [timeLines, setTimeLines] = React.useState([]);
	// The action waiting on a responsible department pick; null while the dialog is closed.
	const [pendingCloseAction, setPendingCloseAction] = React.useState(null);

	React.useEffect(() => {
		setBackground('white');
		getClaimantAnswerData(activeDispute?.id).then((res) => {
			const answerData = res.data?.answers
			const tempObject = answerData?.reduce(
				(obj, item) => Object.assign(obj, { [item.question_text]: { question_id: item.question_id, question: item.question_text, answer: item.answer_value } }), {}
			);
			setClaimantAnswers(tempObject);
			setClaimant(res.data?.complainant?.[0]);
			setLoading(false);
		})
		getCaseTimeline(activeDispute?.id).then((res) => {
			setTimeLines(res.data);
		})
	}, []);

	const download = (e) => {
		e.stopPropagation();
		const params = {
			primary_details: true
		}
		DocGenerator(activeDispute.id, "claimant", "", params);
	};

	// Case file of the officer whose response closed the grievance, read from the
	// muthoot_status it was closed in.
	const getClosingResponseCaseType = () => {
		switch (MUTHOOT_STATUS) {
			// ZO accept moves the grievance to RO_After_Review and closes it.
			case 'RO_After_Review':
				return 'gro';
			// PNO accept closes the grievance without changing muthoot_status.
			case 'Forward_Nodal':
			case 'Nodal_After_Review':
				return 'nodal';
			// IO accept (Forward_MD) and reject/partial (IO_Reject) both close it.
			case 'Forward_MD':
			case 'IO_Reject':
				return 'io';
			case 'MD_Reject':
				return 'md';
			// RO accept (RO_Accept).
			default:
				return RESPONDENT;
		}
	}

	const handleDownloadResponse = () => {
		DocGenerator(activeDispute.id, getClosingResponseCaseType());
	}

	const handleAcceptAndReject = (disputeId, status) => {
		if (activeDispute?.status === RESPONDENT_INPROGRESS ||
			activeDispute?.status === ZONAL_INPROGRESS ||
			activeDispute?.status === NODAL_INPROGRESS ||
			activeDispute?.status === IO_INPROGRESS ||
			activeDispute?.status === MD_INPROGRESS
		) {
			Swal.fire({
				html: `Please complete the response before taking any action on the grievance.`,
				showConfirmButton: false,
				timer: 3000,
				timerProgressBar: true,
			});
			return;
		}
		if (!activeCase?.first_response_recorderd) {
			Swal.fire({
				html: "Please record response before taking any action on the grievance.",
				showConfirmButton: false,
				timer: 3000,
				timerProgressBar: true,
			});
			return;
		}
		if (willCloseGrievance(status)) {
			setPendingCloseAction({ disputeId, status });
			return;
		}
		updateStatus(disputeId, status);
	}

	// Whether this click ends with the grievance closed, mirroring the backend's
	// UpdateMuthootStatusView and MuthootCaseResolveView, so the responsible
	// department is asked for before anything is sent.
	const willCloseGrievance = (status) => {
		// RO accept is resolved only once the complainant's side is complete.
		if (IS_REGIONAL_OFFICER) return status === MUTHOOT_ACCEPT && activeDispute?.status === CLAIMANT_COMPLETE;
		// ZO accept forwards to RO_After_Review, which the resolve API closes.
		if (IS_GRO) return status === MUTHOOT_ACCEPT;
		// PNO accept closes the grievance in the status update itself.
		if (IS_PNO) return status === MUTHOOT_ACCEPT;
		// IO accept (Forward_MD) and reject/partial (IO_Reject) are both closed by the resolve API.
		if (IS_ARBITRATOR) return true;
		// MD reject (MD_Reject) is closed by the resolve API; accept goes back to PNO.
		if (IS_MEDIATOR) return status === 'Reject';
		return false;
	}

	const updateStatus = (disputeId, status, responsibleDepartment) => {
		const departmentPayload = responsibleDepartment
			? { responsible_deparment: responsibleDepartment }
			: undefined;
		// A PNO accept closes the grievance here, so the department goes with the status update.
		const statusPayload = IS_PNO ? { status, ...departmentPayload } : { status };
		dispatch(updateMuthootStatus(disputeId, statusPayload))
			.then((response) => {
				if ((response.muthoot_status === 'IO_Reject' || response.muthoot_status === 'Forward_MD' || response.muthoot_status === 'MD_Reject' || response.muthoot_status === 'RO_After_Review' || response.muthoot_status === 'GRO_After_Review' || (response.status === CLAIMANT_COMPLETE && response.muthoot_status === 'RO_Accept'))) {
					dispatch(MuthootCaseResolved(disputeId, departmentPayload));
				}
			})
	}

	const handleResolve = (disputeId) => {
		if (activeCase?.case_status !== 'review_complete') {
			Swal.fire({
				html: "Please record final response before Resolve the grievance.",
				showConfirmButton: false,
				timer: 3000,
				timerProgressBar: true,
			});
			return;
		}
		setPendingCloseAction({ disputeId });
	}

	// Runs the clicked action only once a department is picked; cancelling the
	// dialog leaves the grievance untouched.
	const handleResponsibleDepartmentSubmit = (responsibleDepartment) => {
		const { disputeId, status } = pendingCloseAction;
		setPendingCloseAction(null);

		// The RO "Resolve" button calls the resolve API directly.
		if (!status) {
			dispatch(MuthootCaseResolved(disputeId, { responsible_deparment: responsibleDepartment }));
			return;
		}
		updateStatus(disputeId, status, responsibleDepartment);
	}

	function ComplainantDetails() {
		const isTempEmail = claimant?.email && claimant?.email.startsWith("muthoot_temp_email");
		const isTempPhone = claimant?.phone_number && claimant?.phone_number.startsWith("000122");
		return (
			<Paper className={classes.claimantDetailsContainer}>
				<Typography className={classes.claimantDetailsHeading}>
					{activeDispute.name.split("&")[0]}
				</Typography>
				<Typography className={classes.claimantDetailsStatus} style={activeDispute.status === 'closed' ? { backgroundColor: '#caf4d1' } : { backgroundColor: '#ffefeb' }}>
					{activeDispute.status === 'closed' ? 'Complaint Resolved' : 'Complaint in progress'}
				</Typography>
				<Box className={classes.claimantDetailsRow}>
					<Grid
						container
						justify="space-between"
						spacing={1}
					>
						<Grid item xs={6}>
							<Typography className={classes.boldText}>
								Complaint ID
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Typography>
								{activeDispute?.id}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				<Box className={classes.claimantDetailsRow}>
					<Grid
						container
						justify="space-between"
						spacing={1}
					>
						<Grid item xs={6}>
							<Typography className={classes.boldText}>
								Email
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Typography>
								{isTempEmail ? '---' : claimant?.email}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				<Box className={classes.claimantDetailsRow}>
					<Grid
						container
						justify="space-between"
						spacing={1}
					>
						<Grid item xs={6}>
							<Typography className={classes.boldText}>
								Phone No.
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Typography>
								{isTempPhone ? '---' : claimant?.phone_number ? claimant?.phone_number : '---'}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				<Box className={classes.claimantDetailsRow}>
					<Grid
						container
						justify="space-between"
						spacing={1}
					>
						<Grid item xs={6}>
							<Typography className={classes.boldText}>
								Type
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Typography style={{ textTransform: 'capitalize' }}>
								{activeDispute?.grievance_type ? activeDispute?.grievance_type : '---'}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				<Box className={classes.claimantDetailsRow}>
					<Grid
						container
						justify="space-between"
						spacing={1}
					>
						<Grid item xs={6}>
							<Typography className={classes.boldText}>
								Loan Account No.
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Typography>
								{claimantAnswers['Please enter your loan account number with Muthoot Finance']?.answer}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				<Box className={classes.claimantDetailsRow}>
					<Grid
						container
						justify="space-between"
						spacing={1}
					>
						<Grid item xs={6}>
							<Typography className={classes.boldText}>
								Loan Type
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Typography>
								{activeDispute?.customer_type}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				<Box className={classes.claimantDetailsRow}>
					<Grid
						container
						justify="space-between"
						spacing={1}
					>
						<Grid item xs={6}>
							<Typography className={classes.boldText}>
								Branch
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Typography>
								{activeDispute?.city}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				{!IS_END_USER && (
					<Box className={classes.claimantDetailsRow}>
						<Grid
							container
							justify="space-between"
							spacing={1}
						>
							<Grid item xs={6}>
								<Typography className={classes.boldText}>
									Responsible Department
								</Typography>
							</Grid>
							<Grid item xs={6} style={{ textAlign: 'right' }}>
								<Typography>
									{activeDispute?.responsible_deparment ? activeDispute?.responsible_deparment : '---'}
								</Typography>
							</Grid>
						</Grid>
					</Box>
				)}
				<Box className={classes.claimantDetailsRow} style={{ border: 'none', marginTop: '0.5rem' }}>
					<Button
						variant="outlined"
						fullWidth
						style={{ color: 'black', backgroundColor: 'white' }}
						startIcon={<img src={downloadIcon} style={{ width: '1.3rem' }} alt="" />}
						onClick={download}
					>
						Download Complaint
					</Button>
					<Box style={{ height: '1rem' }} />
					{IS_END_USER && (
						<Button
							className={classes.button}
							variant="outlined"
							fullWidth
							style={{ backgroundColor: 'white' }}
							startIcon={<img src={downloadIcon} style={{ width: '1.3rem' }} alt="" />}
							onClick={handleDownloadResponse}
							disabled={activeDispute.status !== 'closed'}
						>
							Download Response
						</Button>
					)

					}
				</Box>
			</Paper>
		);
	}

	function TrackProgress() {
		return (
			<Paper className={classes.disputeStatusContainer}>
				<Typography className={classes.disputeStatusHeading}>
					{activeDispute.status === 'closed' ? 'Resolved' : 'In Progress'}
				</Typography>
				<Box style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
					<Typography style={{ color: '#4b4e56', fontFamily: 'Satoshi-Bold' }}>
						Updated
					</Typography>
					<Typography>
						{format(new Date(activeDispute?.modified), "dd MMMM, y, h:mm a")}
					</Typography>
				</Box>
				<Box>
					<ShowProgress activeDispute={activeDispute} IS_END_USER={IS_END_USER} timeLines={timeLines} />
				</Box>
			</Paper>
		);
	}

	const handleClickRecordResponse = () => {
		const casePayload = {
			proposed_flow: ARBITRATION,
			id: activeCase.id
		}
		const endUserCasePayload = {
			case_status: 'new',
			proposed_flow: ARBITRATION,
			id: activeCase.id
		}
		dispatch(
			updateCase(IS_END_USER ? endUserCasePayload : casePayload)
		)
			.then((response) => {
				let disputePayload = {
					id: activeDispute.id,
					status: IS_ARBITRATOR ? IO_INPROGRESS : IS_MEDIATOR ? MD_INPROGRESS : IS_PNO ? NODAL_INPROGRESS : IS_GRO ? ZONAL_INPROGRESS : RESPONDENT_INPROGRESS,
					flow_type: ARBITRATION,
				};
				!IS_END_USER && dispatch(updateDispute(disputePayload));
				setResume(true);
			})
			.catch((err) => {
				console.log(err);
			});
	}

	const isAcceptOrRejectButtonDisabled = () => {
		return (
			activeDispute?.status === 'closed' ||
			MUTHOOT_STATUS === 'RO_Accept' ||
			(MUTHOOT_STATUS === 'Forward' && !IS_GRO) ||
			MUTHOOT_STATUS === RO_AFTER_REVIEW ||
			(MUTHOOT_STATUS === 'Forward_Nodal' && !IS_PNO) ||
			MUTHOOT_STATUS === 'GRO_After_Review' ||
			(MUTHOOT_STATUS === 'Forward_IO' && !IS_ARBITRATOR) ||
			(MUTHOOT_STATUS === 'Forward_MD' && !IS_MEDIATOR) ||
			MUTHOOT_STATUS === 'IO_Reject' ||
			MUTHOOT_STATUS === 'Nodal_After_Review' ||
			MUTHOOT_STATUS === 'MD_Reject'
		)
	}


	const viewerRole = IS_MEDIATOR ? 'MD' : (IS_ARBITRATOR || activeDispute?.unread?.includes(profile?.id.toString())) ? 'IO' : IS_PNO ? 'PNO' : IS_GRO ? 'ZO' : IS_REGIONAL_OFFICER ? 'RO' : 'RESPONDENT';

	if (loading) return <CircularCenteredLoader />;

	return (
		<Grid container justify="center" style={{ backgroundColor: 'white', height: '100%' }}>
			<Grid item lg={11} md={10} sm={11} xs={11} className={classes.root}>
				<Button
					disableElevation
					disableFocusRipple
					disableRipple
					disableTouchRipple
					style={{ backgroundColor: "transparent", cursor: "default" }}
				>
					<Grid container spacing={1}>
						<Grid item>
							<Typography
								className={classes.btntext}
								style={{ color: "black", cursor: 'pointer' }}
								onClick={() => {
									history.goBack();
								}}
							>
								<KeyboardBackspace />
							</Typography>
						</Grid>
						<Grid item>
							<Typography
								className={`${classes.btntext} ${classes.hov}`}
								style={{ cursor: "pointer" }}
								onClick={() => {
									history.push("/");
								}}
							>
								Dashboard
							</Typography>
						</Grid>
						<Grid item>
							<Typography
								className={classes.btntext}
								style={{ color: "black" }}
							>
								/
							</Typography>
						</Grid>
						<Grid item>
							<Typography
								className={`${classes.btntext} ${classes.hov}`}
								style={{ cursor: "pointer" }}
								onClick={() => {
									history.push(`/disputes/${activeDispute.id}/`);
								}}
							>
								{activeDispute.name}
							</Typography>
						</Grid>
					</Grid>
				</Button>
				<Grid container style={{ justifyContent: 'space-between', gap: '1rem', alignItems: 'center' }}>
					<Grid item xs>
						<Typography className="lineClamp" style={{ fontFamily: 'Satoshi-Bold' }}>{activeDispute?.description}</Typography>
					</Grid>
					<Grid item style={{ display: 'flex', gap: '1rem' }}>
						<Box style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
							<Typography>
								{format(new Date(activeDispute?.created), "dd MMMM, y, h:mm a")}
							</Typography>
							<Typography>
								({calc_days(activeDispute?.created) === 0 ? 'Today' : calc_days(activeDispute?.created) + ' day ago'})
							</Typography>
						</Box>
						{!IS_ADMIN && !IS_END_USER && !IS_CALL_CENTER && (
							<>
								{((MUTHOOT_STATUS === 'Nodal_After_Review' && IS_PNO) || (MUTHOOT_STATUS === 'GRO_After_Review' && IS_GRO) || (MUTHOOT_STATUS === RO_AFTER_REVIEW && IS_REGIONAL_OFFICER)) ? (
									<>
										<Button
											variant="contained"
											color="primary"
											style={{ padding: '5px 15px' }}
											disabled={activeDispute?.status === 'closed' || (MUTHOOT_STATUS === 'GRO_After_Review' && IS_PNO) || (MUTHOOT_STATUS === RO_AFTER_REVIEW && IS_GRO)}
											onClick={() => (MUTHOOT_STATUS === RO_AFTER_REVIEW) ? handleResolve(activeDispute?.id) : handleAcceptAndReject(activeDispute.id, MUTHOOT_ACCEPT)}
										>
											{MUTHOOT_STATUS === 'Nodal_After_Review'
												? 'Resolve'
												: MUTHOOT_STATUS === 'GRO_After_Review'
													? 'Forward to RO'
													: 'Resolve'
											}
										</Button>
									</>
								) : (
									<>
										<Button
											variant="contained"
											color="primary"
											style={{ padding: '5px 15px' }}
											disabled={isAcceptOrRejectButtonDisabled()}
											onClick={() => handleAcceptAndReject(activeDispute.id, MUTHOOT_ACCEPT)}
										>
											{
												// ((MUTHOOT_STATUS === 'Forward_MD' || MUTHOOT_STATUS === 'MD_Reject') && IS_MEDIATOR) ?
												// 	'Agree with IO' :
												// 	(MUTHOOT_STATUS === 'Nodal_After_Review' && IS_MEDIATOR) ?
												// 	'Agreed with IO' :
												// 	(MUTHOOT_STATUS === 'RO_Accept' || 
												// 	MUTHOOT_STATUS === RO_AFTER_REVIEW || 
												// 	MUTHOOT_STATUS === 'GRO_After_Review' || 
												// 	(MUTHOOT_STATUS === 'Forward_MD' && IS_ARBITRATOR)) ? 
												// 	'Accepted' : 'Accept'
												'Fully Resolved'
											}
										</Button>
										<Button
											className={classes.button}
											variant="outlined"
											// style={{color: 'black'}}
											disabled={isAcceptOrRejectButtonDisabled()}
											onClick={() => handleAcceptAndReject(activeDispute.id, 'partially_resolved')}
										>
											{
												'Partially Resolved'
											}
										</Button>
										<Button
											className={classes.button}
											variant="outlined"
											// style={{color: 'black'}}
											disabled={isAcceptOrRejectButtonDisabled()}
											onClick={() => handleAcceptAndReject(activeDispute.id, 'Reject')}
										>
											{
												// ((MUTHOOT_STATUS === 'Forward_MD' || MUTHOOT_STATUS === 'Nodal_After_Review') && IS_MEDIATOR) ?
												// 	'Agree with PNO' :
												// 	(MUTHOOT_STATUS === 'MD_Reject' && IS_MEDIATOR) ?
												// 	'Agreed with PNO' :
												// 	((MUTHOOT_STATUS === 'Forward' && !IS_GRO) || 
												// 	(MUTHOOT_STATUS === 'Forward_Nodal' && !IS_PNO) || 
												// 	(MUTHOOT_STATUS === 'Forward_IO' && !IS_ARBITRATOR) || 
												// 	(MUTHOOT_STATUS === 'IO_Reject' && !IS_MEDIATOR)) ? 
												// 	'Rejected' : 'Reject'
												'Wholly Rejected'
											}
										</Button>
									</>
								)}
							</>
						)}
					</Grid>
					<Grid item xs={12} style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
						<Box>
							{!IS_ADMIN && !IS_CALL_CENTER && (
								(((activeDispute.status === RESPONDENT_INPROGRESS && IS_REGIONAL_OFFICER) ||
									(activeDispute.status === ZONAL_INPROGRESS && IS_GRO) ||
									(activeDispute.status === NODAL_INPROGRESS && IS_PNO) ||
									(activeDispute.status === IO_INPROGRESS && IS_ARBITRATOR) ||
									(activeDispute.status === MD_INPROGRESS && IS_MEDIATOR)) &&
									(activeCase?.case_status !== 'review_complete')) ? (
									<Button
										color="primary"
										style={{ textDecoration: 'underline' }}
										onClick={() => setResume(true)}
									>
										Resume Response
									</Button>
								) : (
									<Button
										className={classes.button}
										variant="outlined"
										// style={{color: 'black'}}
										disabled={
											(!IS_END_USER && activeCase?.case_status === 'review_complete') ||
											activeDispute.status === 'closed' ||
											activeDispute.status === RESPONDENT_INPROGRESS ||
											activeDispute.status === IO_INPROGRESS ||
											activeDispute.status === MD_INPROGRESS ||
											activeDispute.status === ZONAL_INPROGRESS ||
											activeDispute?.status === NODAL_INPROGRESS ||
											MUTHOOT_STATUS === 'IO_Reject' ||
											MUTHOOT_STATUS === 'MD_Reject' ||
											// Only allow recording when the viewer's role matches the dispute's current assigned role
											(viewerRole !== getMuthootRole(MUTHOOT_STATUS) && !IS_END_USER && !(IS_REGIONAL_OFFICER && MUTHOOT_STATUS === RO_AFTER_REVIEW))
										}
										onClick={handleClickRecordResponse}
									>
										{IS_END_USER ? 'Write to us' : ((activeDispute.status === RO_AFTER_REVIEW && IS_REGIONAL_OFFICER)) ? 'Record Final Response' : 'Record Response'}
									</Button>
								)

							)}
						</Box>
					</Grid>
				</Grid>
				<Box style={{ height: '2rem' }} />
				<Grid container spacing={2}>
					<Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
						<ComplainantDetails />
					</Grid>
					<Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
						<TrackProgress />
					</Grid>
				</Grid>
			</Grid>
			<ResponsibleDepartmentDialog
				open={Boolean(pendingCloseAction)}
				onClose={() => setPendingCloseAction(null)}
				onSubmit={handleResponsibleDepartmentSubmit}
			/>
		</Grid>
	);
}
